export default "__VITE_ASSET__CEzU5VpH__"